import React, { useState, useEffect } from 'react';
import { TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { updatePrioritizedGames, getPrioritizedGames } from '../utils/api';

const vendorsList = [
  'evolution', 'sports', 'pragmaticlive', 'netent', 'ezugi', 'spribe', 'km', 'hacksaw',
  'pragmatic', 'ideal', 'microgaming', 'dpesports', 'pgsoft', '2j', 'jili'
];

const PrioritizedGames: React.FC = () => {
  const [vendor, setVendor] = useState('');
  const [gameIds, setGameIds] = useState<string>('');
  const [prioritizedGames, setPrioritizedGames] = useState<any[]>([]);

  useEffect(() => {
    fetchPrioritizedGames();
  }, []);

  const fetchPrioritizedGames = async () => {
    try {
      const response = await getPrioritizedGames();
      setPrioritizedGames(response.data.data); // Adjust based on response structure
    } catch (err) {
      console.error('Failed to fetch prioritized games', err);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const ids = gameIds.split(',').map((id) => parseInt(id.trim()));
      await updatePrioritizedGames(vendor, ids);
      alert('Prioritized games updated');
      setGameIds('');
      fetchPrioritizedGames();
    } catch (err) {
      console.error('Failed to update prioritized games', err);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Vendor</InputLabel>
          <Select value={vendor} onChange={(e) => setVendor(e.target.value)}>
            {vendorsList.map((v) => (
              <MenuItem key={v} value={v}>{v}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Game IDs (comma-separated)"
          value={gameIds}
          onChange={(e) => setGameIds(e.target.value)}
          fullWidth
          margin="normal"
        />
        <Button type="submit" variant="contained" color="primary">
          Update Prioritized Games
        </Button>
      </form>
      <h3>Current Prioritized Games</h3>
      {prioritizedGames.map((pg) => (
        <div key={pg.id}>{pg.vendor}: {pg.game_ids}</div>
      ))}
    </div>
  );
};

export default PrioritizedGames;